















import BuilderSettingsForm from "@tool/Components/BuilderSettingsForm.vue";
import {defineComponent, ref} from "@vue/composition-api";
import useBuilderStore from "@tool/store/useBuilderStore";
import {BvModalEvent} from "bootstrap-vue/src/components/modal";
import {useToast} from "vue-toastification/composition";

export default defineComponent({
    components: {
        BuilderSettingsForm
    },
    setup() {

        const {saveBuilderSettings, showModalSettings} = useBuilderStore();

        const toast = useToast();
        const formIsLoading = ref(false);

        const formSubmit = async (event: BvModalEvent) => {
            event.preventDefault();

            formIsLoading.value = true;

            try {
                await saveBuilderSettings();
                toast.success('Your settings were successfully saved');
            } catch (e) {
                toast.error('Something went wrong and your settings were not saved.')
            }

            formIsLoading.value = false;
            showModalSettings.value = false;
        }

        return {
            showModalSettings,
            formSubmit,
            formIsLoading,
        }
    }
});


